import { render, staticRenderFns } from "./slide-popup-layout.vue?vue&type=template&id=544c5205&scoped=true&"
import script from "./slide-popup-layout.ts?vue&type=script&lang=ts&"
export * from "./slide-popup-layout.ts?vue&type=script&lang=ts&"
import style0 from "./slide-popup-layout.scss?vue&type=style&index=0&id=544c5205&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c5205",
  null
  
)

export default component.exports